"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ViewMediaReadStats = _interopRequireDefault(require("../model/ViewMediaReadStats"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* MediaReadStats service.
* @module api/MediaReadStatsApi
* @version 1.1.3-alpha.1
*/
class MediaReadStatsApi {
  /**
  * Constructs a new MediaReadStatsApi. 
  * @alias module:api/MediaReadStatsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Get media
   * Returns the requested media
   * @param {String} id Id of the media to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ViewMediaReadStats} and HTTP response
   */
  getWithHttpInfo(id) {
    let postBody = null;
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling get");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _ViewMediaReadStats.default;
    return this.apiClient.callApi('/api/v1/MediaReadStats/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get media
   * Returns the requested media
   * @param {String} id Id of the media to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ViewMediaReadStats}
   */
  get(id) {
    return this.getWithHttpInfo(id).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get multiple media read statistics
   * Returns an array of requested media read statistics
   * @param {Object} opts Optional parameters
   * @param {Array.<String>} opts.request_body Ids of the media read statistics to get. Not specifiying ids will return all media read statistics
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ViewMediaReadStats>} and HTTP response
   */
  getManyWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['request_body'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = [_ViewMediaReadStats.default];
    return this.apiClient.callApi('/api/v1/MediaReadStats/getMany', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get multiple media read statistics
   * Returns an array of requested media read statistics
   * @param {Object} opts Optional parameters
   * @param {Array.<String>} opts.request_body Ids of the media read statistics to get. Not specifiying ids will return all media read statistics
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ViewMediaReadStats>}
   */
  getMany(opts) {
    return this.getManyWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }
}
exports.default = MediaReadStatsApi;